import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { useFormattingContext } from '../../../../FormattingProvider/FormattingContext'

function StatusReportMetadataDisplay ({
  statusReportItemMetadataId,
  displayName,
  value,
  valueType
}) {
  const { formatter } = useFormattingContext()
  const displayValue = useMemo(() => {
    if (!valueType) return value

    switch (valueType) {
      case 'date':
        return formatter(value, '@MM/DD/YY')
      case 'boolean':
        return value ? 'Yes' : 'No'
      case 'number':
        return formatter(value, '0,0')
      default:
        return value
    }
  }, [valueType, value, formatter])

  if (!value) return null

  return (
    <div
      key={`statusReportItemMetadata_${statusReportItemMetadataId}`}
      className='p-1 rounded bg-surface-050 border border-neutral-300 flex items-center'
      style={{ minWidth: 0, fontSize: '8px' }}
    >
      {displayName}: {displayValue}
    </div>
  )
}

StatusReportMetadataDisplay.propTypes = {
  statusReportItemMetadataId: PropTypes.number.isRequired,
  displayName: PropTypes.string.isRequired,
  value: PropTypes.string,
  valueType: PropTypes.string.isRequired
}

export default StatusReportMetadataDisplay
